import React from "react";
import "../../App.css";
import "./Card.css";
import CardItem from "./CardItem";
import web from "../images/card1.jpg";
import web2 from "../images/card2.jpg";
import { Fade } from "react-reveal";
const Card = () => {
	return (
		<section className="card_wrapper">
			<div className="container  ">
				<Fade up>
					<div className="text-center">
						<span className="subtitle ">
							Learn More About Startups & Entrepreneurship
						</span>
						<h2 className="mb-2">Startup Buildup Session</h2>
					</div>
				</Fade>
				<div className="row gy-4 py-4">
					<div className="col-md-6 col-sm-12">
						<CardItem
							src={web2}
							plan="1 MONTH PLAN"
							title="STARTUP WORKSHOP"
							li1a="Entrepreneurial skill Developenent"
							li1b="Presentation and Goal setting"
							li1c="Business and Entrepreneurship"
							li1d="Launch your idea"
							path="/about"
							price="Price Rs. 9,999"
						/>
					</div>
					<div className="col-md-6 col-sm-12">
						<CardItem
							src={web}
							plan="2 MONTH PLAN"
							title="MICRO BUSINESS SESSION"
							li2a="Creation and Commercialization"
							li2b="Market research and consultency"
							li2c="Pitch the investors "
							li2d="Startup building training"
							path="/about"
							price="Price RS. 14,999"
						/>
					</div>
				</div>
			</div>
		</section>
	);
};
export default Card;
